import type { CSSProperties } from 'react'
import { GIFT_RESOURCE_ICONS } from '../diplomacy/constants'
import { MVM_BATTLE_UI_FONT_FAMILY } from '../../pages/hex-battle/constants'

const TEXT_SECONDARY = 'rgba(228,220,200,.72)'
const TEXT_MUTED = 'rgba(228,220,200,.52)'

/** Shared chrome for victory / defeat dismiss buttons (palette differs). */
const MVM_RESULT_BACK_BUTTON_BASE: CSSProperties = {
  padding: '10px 36px',
  borderRadius: 8,
  fontSize: 14,
  fontWeight: 700,
  fontFamily: MVM_BATTLE_UI_FONT_FAMILY,
  cursor: 'pointer',
}

export const mvmVictoryBackButtonStyle: CSSProperties = {
  ...MVM_RESULT_BACK_BUTTON_BASE,
  border: '1px solid rgba(170, 235, 190, 0.55)',
  background: 'linear-gradient(180deg, #66bb6a 0%, #43a047 48%, #2e7d32 100%)',
  color: '#f6fff8',
  boxShadow: '0 4px 18px rgba(0, 90, 40, 0.45), inset 0 1px 0 rgba(255,255,255,0.22)',
}

export const mvmDefeatBackButtonStyle: CSSProperties = {
  ...MVM_RESULT_BACK_BUTTON_BASE,
  border: '1px solid rgba(255, 170, 170, 0.5)',
  background: 'linear-gradient(180deg, #e53935 0%, #c62828 48%, #8e1515 100%)',
  color: '#fff8f6',
  boxShadow: '0 4px 18px rgba(139, 0, 0, 0.5), inset 0 1px 0 rgba(255,255,255,0.22)',
}

/** 1k, 1.54k, 12.5m style for rewards / XP (absolute value; sign passed separately). */
export function formatCompactResourceAmount(value: number): string {
  let v = Math.abs(Number(value))
  if (!Number.isFinite(v)) return '0'
  v = Math.floor(v)
  const fmt = (x: number, div: number, suffix: string) => {
    const t = x / div
    let s: string
    if (t >= 100) s = t.toFixed(0)
    else if (t >= 10) s = t.toFixed(1)
    else s = t.toFixed(2)
    s = s.replace(/\.?0+$/, '')
    return `${s}${suffix}`
  }
  if (v < 1000) return String(v)
  if (v < 1_000_000) {
    const k = v / 1000
    if (k >= 999.5) return '1m'
    return fmt(v, 1000, 'k')
  }
  return fmt(v, 1_000_000, 'm')
}

export function resourceIconForKey(key: string): string | null {
  const k = String(key || '').toLowerCase().trim()
  return GIFT_RESOURCE_ICONS[k] ?? null
}

export const mvmResultSummaryTextStyle: CSSProperties = {
  color: TEXT_SECONDARY,
  fontSize: 'clamp(1.35dvh, 1.65dvh, 13px)',
  lineHeight: 1.55,
  margin: 0,
  textAlign: 'center',
}

export const mvmResultMutedStyle: CSSProperties = {
  color: TEXT_MUTED,
  fontSize: 'clamp(1.2dvh, 1.5dvh, 12px)',
  lineHeight: 1.5,
  margin: 'clamp(0.45dvh, 0.65dvh, 6px) 0 0',
  textAlign: 'center',
}
